interface PaginationDescriptor
{
	name: string;
	id?: string;
	label?: string;
}

interface PaginationPageDescriptor
	extends PaginationDescriptor
{
	text: string;
	href: string;
	disabled?: boolean;
	active?: boolean;
}

/*	EXAMPLE
		var Pagination_1 = new Pagination( {id:'pag7d7w'} );

		Pagination_1.addPage( {id:'pag793w', name:'', href: '#s', text: '&laquo;'} );
		Pagination_1.addPage( {id:'pag794w', name:'', href: '#e', text: 'zwei', disabled: true} );
		Pagination_1.addPage( {id:'pag793s', name:'', href: '#d', text: 'drei'} );
		Pagination_1.addPage( {id:'pag793o', name:'', href: '#o', text: 'vier'} );
		Pagination_1.addPage( {id:'pag793d', name:'', href: '#s', text: '&raquo;'} );

		$( '#global_container' ).append( Pagination_1.getElement() );
*/
class Pagination
{

	protected element: HTMLElement;
	protected ul: HTMLElement;
	protected li?: HTMLElement;
	protected a?: HTMLElement;

	constructor(
		descriptor: PaginationDescriptor,
	)
	{
		this.element = document.createElement( 'nav' );
		this.ul = document.createElement( 'ul' );

		if ( descriptor.id )
		{
			$( this.element ).attr( 'id', descriptor.id );
		}
		$( this.element ).attr( 'name', descriptor.name );

		if ( descriptor.label != null )
		{
			$( this.element ).attr( 'aria-label', descriptor.label );
		}

		$( this.ul ).addClass( 'pagination' );
		$( this.element ).append( this.ul );
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

	public addPage( descriptor: PaginationPageDescriptor )
	{
		this.li = document.createElement( 'li' );
		this.a = document.createElement( 'a' );

		if ( descriptor.disabled )
		{
			$( this.li ).addClass( 'disabled' );
		}

		if ( descriptor.active )
		{
			$( this.li ).addClass( 'active' );
		}

		$( this.a ).attr( 'href', descriptor.href );
		$( this.a ).html( descriptor.text );

		$( this.li ).append( this.a );
		$( this.ul ).append( this.li );
	}

}
